/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { chakra } from 'chakra-v3';
import { linkRecipe } from '../theme/recipes/Link.recipe';

/**
 * Link component created directly from the link recipe.
 * This is the recommended approach according to Chakra UI documentation.
 *
 * Variants:
 * - 'whatsapp': Styled link for WhatsApp Web links with blue color, larger font, and hover effects
 * - 'plain': Plain link with no special styling, used in navigation menus
 * - 'underline': Underlined link variant, used in footer and external links
 * - 'footer': Footer navigation link with primary text color and accent hover
 * - 'card': Full-width card container link with block display
 *
 * @example
 * ```tsx
 * <Link variant="whatsapp" href="https://web.whatsapp.com" target="_blank">
 *   Go to WhatsApp Web
 * </Link>
 * <Link variant="plain" href="/page">Plain Link</Link>
 * <Link variant="footer" href="#features">Footer Link</Link>
 * <Link variant="card" href="/project">Card Link</Link>
 * ```
 */
export const Link = chakra('a', linkRecipe);
